(function(){
  'use strict';

  document.addEventListener('DOMContentLoaded', init);

  function init(){
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hasHover = window.matchMedia('(hover: hover)').matches;

    /* ---- word-by-word heading split (must run before reveal observer attaches) ----
       Sets both transition-delay (sales-page .reveal/.in-view system) and
       animation-delay (quiz's .qs.on keyframe system) so the same markup works
       under either trigger mechanism. */
    document.querySelectorAll('[data-split-words]').forEach(function(el){
      var words = el.textContent.trim().split(/\s+/);
      el.innerHTML = words.map(function(w, i){
        var delay = (i * 45) + 'ms';
        return '<span class="word"><span style="transition-delay:' + delay + ';animation-delay:' + delay + '">' + w + '</span></span>';
      }).join(' ');
    });

    /* ---- scroll-linked word reveal (data-scroll-text) ----
       Vanilla re-implementation of a scroll-progress word fade (ghost + lit
       overlay): words brighten as their line moves up through a fixed
       viewport band, rather than firing once via IntersectionObserver.
       Opt-in per element — most headings still use the reveal system below. */
    var scrubTargets = [];
    document.querySelectorAll('[data-scroll-text]').forEach(function(el){
      var words = el.textContent.trim().split(/\s+/);
      el.innerHTML = words.map(function(w){
        return '<span class="scrub-word"><span class="scrub-word-ghost">' + w + '</span><span class="scrub-word-lit">' + w + '</span></span>';
      }).join(' ');
      var lits = el.querySelectorAll('.scrub-word-lit');
      if (reduceMotion){
        lits.forEach(function(s){ s.style.opacity = 1; });
      } else {
        scrubTargets.push({ el: el, words: lits });
      }
    });
    if (scrubTargets.length){
      var scrubPending = false;
      var updateScrubText = function(){
        scrubPending = false;
        var vh = window.innerHeight;
        var startY = vh * 0.9, endY = vh * 0.25;
        scrubTargets.forEach(function(t){
          var rect = t.el.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > vh) return;
          var progress = (startY - rect.top) / (startY - endY);
          progress = Math.max(0, Math.min(1, progress));
          var n = t.words.length;
          t.words.forEach(function(w, i){
            var start = i / n, end = (i + 1) / n;
            var op = (progress - start) / (end - start);
            w.style.opacity = Math.max(0, Math.min(1, op));
          });
        });
      };
      window.addEventListener('scroll', function(){
        if (scrubPending) return;
        scrubPending = true;
        requestAnimationFrame(updateScrubText);
      }, { passive: true });
      window.addEventListener('load', updateScrubText);
      updateScrubText();
    }

    /* ---- What's Inside: scroll-linked timeline fill ----
       Vanilla port of the source component's useScroll-driven height
       transform: as the whole timeline block scrolls from just below the
       viewport top to its own end, the track-fill grows from 0% to 100%
       height. Runs on every viewport width — the fill/dots stay visible
       on mobile even though the big sticky "Week N" label is CSS-hidden
       there, matching the reference's own mobile behavior of keeping the
       line/dots while swapping only the label presentation. */
    var tlWrap = document.getElementById('tl-wrap');
    var tlFill = document.getElementById('tl-fill');
    if (tlWrap && tlFill){
      var tlPending = false;
      function updateTlFill(){
        tlPending = false;
        var rect = tlWrap.getBoundingClientRect();
        var vh = window.innerHeight;
        var start = vh * 0.85;
        var span = rect.height + (start - vh * 0.5);
        var progress = span > 0 ? (start - rect.top) / span : 0;
        progress = Math.max(0, Math.min(1, progress));
        tlFill.style.height = (progress * 100) + '%';
      }
      window.addEventListener('scroll', function(){
        if (tlPending) return;
        tlPending = true;
        requestAnimationFrame(updateTlFill);
      }, { passive: true });
      window.addEventListener('resize', updateTlFill);
      window.addEventListener('load', updateTlFill);
      updateTlFill();
    }

    /* ---- shared scroll-reveal (single observer for the whole page) ---- */
    var revealObs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ e.target.classList.add('in-view'); revealObs.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function(el){ revealObs.observe(el); });

    /* ---- reveal safety net ----
       IntersectionObserver occasionally misses a target — confirmed on-device:
       an on-screen .reveal element that stayed at opacity:0 (invisible content)
       despite the primary observer never firing for it. Invisible content is a
       worse failure than "no animation," so back the observer with a cheap
       scroll-driven sweep that force-reveals anything already on-screen but
       still missing .in-view. No-ops (near-zero cost) once everything's revealed. */
    var sweepPending = false;
    function sweepMissedReveals(){
      sweepPending = false;
      var vh = window.innerHeight;
      document.querySelectorAll('.reveal:not(.in-view)').forEach(function(el){
        var r = el.getBoundingClientRect();
        if (r.top < vh && r.bottom > 0) el.classList.add('in-view');
      });
    }
    window.addEventListener('scroll', function(){
      if (sweepPending) return;
      sweepPending = true;
      requestAnimationFrame(sweepMissedReveals);
    }, { passive: true });
    window.addEventListener('load', function(){ setTimeout(sweepMissedReveals, 300); });

    /* ---- nav + subnav height → CSS vars ----
       Both bars are position:fixed (see spiritpath.css for why), so body's
       padding-top and html's scroll-padding-top have to reserve their real
       combined height instead of assuming a fixed number — logo/link
       changes on either bar can't silently drift out of sync with the
       actual layout. Measuring once (and on resize) removes that whole
       class of bug. */
    var navEl = document.querySelector('.sp-nav');
    var subnav = document.getElementById('sp-subnav');
    var hero = document.getElementById('hero');
    function syncNavHeight(){
      if (navEl) document.documentElement.style.setProperty('--nav-h', navEl.getBoundingClientRect().height + 'px');
      if (subnav) document.documentElement.style.setProperty('--subnav-h', subnav.getBoundingClientRect().height + 'px');
    }
    syncNavHeight();
    window.addEventListener('resize', syncNavHeight);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncNavHeight);

    /* ---- section-jump sub-nav (always visible; scrollspy highlights the active section) ---- */
    if (subnav){
      var backToTop = subnav.querySelector('[data-subnav-top]');
      if (backToTop){
        backToTop.addEventListener('click', function(){
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
      var links = subnav.querySelectorAll('[data-subnav-link]');
      var linkMap = {};
      links.forEach(function(a){ linkMap[a.getAttribute('href').replace('#','')] = a; });

      var targets = Object.keys(linkMap)
        .map(function(id){ return document.getElementById(id); })
        .filter(Boolean);

      if (targets.length){
        var spyObs = new IntersectionObserver(function(entries){
          entries.forEach(function(e){
            if (e.isIntersecting){
              links.forEach(function(a){ a.classList.remove('active'); });
              var active = linkMap[e.target.id];
              if (active){
                active.classList.add('active');
                active.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
              }
            }
          });
        }, { threshold: 0, rootMargin: '-35% 0px -55% 0px' });
        targets.forEach(function(t){ spyObs.observe(t); });
      }
    }

    /* ---- sticky mobile CTA bar ---- */
    var stickyBar = document.getElementById('sp-sticky-cta');
    var pricing = document.getElementById('sp-pricing');
    if (stickyBar && hero && pricing){
      var heroPast = false;
      var pricingVisible = false;
      function syncSticky(){ stickyBar.classList.toggle('is-visible', heroPast && !pricingVisible); }

      new IntersectionObserver(function(entries){
        entries.forEach(function(e){ heroPast = !e.isIntersecting; syncSticky(); });
      }, { threshold: 0 }).observe(hero);

      new IntersectionObserver(function(entries){
        entries.forEach(function(e){ pricingVisible = e.isIntersecting; syncSticky(); });
      }, { threshold: 0.1 }).observe(pricing);
    }

    /* ---- custom cursor (desktop pointer only) ----
       Applied via a class on <html> so if this script never runs, the
       native cursor is simply left alone — no lock-out, pure enhancement. */
    if (hasHover && !reduceMotion){
      var cursor = document.getElementById('sp-cursor');
      if (cursor){
        var dot = cursor.querySelector('.sp-cursor-dot');
        var ring = cursor.querySelector('.sp-cursor-ring');
        var mx = 0, my = 0, rx = 0, ry = 0, started = false;

        document.documentElement.classList.add('has-custom-cursor');

        document.addEventListener('mousemove', function(e){
          mx = e.clientX; my = e.clientY;
          dot.style.transform = 'translate(' + mx + 'px,' + my + 'px)';
          if (!started){ started = true; rx = mx; ry = my; requestAnimationFrame(tick); }
        });

        function tick(){
          rx += (mx - rx) * 0.18;
          ry += (my - ry) * 0.18;
          ring.style.transform = 'translate(' + rx.toFixed(1) + 'px,' + ry.toFixed(1) + 'px)';
          requestAnimationFrame(tick);
        }

        var hoverSelector = 'a, button, .q-opt, .price-card, .status-row, .gift-card, .tl-row, .faq-q, input';
        document.addEventListener('mouseover', function(e){
          if (e.target.closest && e.target.closest(hoverSelector)) ring.classList.add('is-active');
        });
        document.addEventListener('mouseout', function(e){
          if (e.target.closest && e.target.closest(hoverSelector)) ring.classList.remove('is-active');
        });
      }
    }

    /* ---- 3D tilt + glow card (data-motion="tilt") ----
       Hover-driven mouse tilt with a cursor-following radial glow, replacing
       the old GSAP scroll-pin sequence that drove this same book mockup —
       one fewer external script, and the motion now matches user intent
       (look here) rather than firing on scroll regardless of attention.
       Desktop pointer only; a static card is a fine fallback everywhere else. */
    if (hasHover && !reduceMotion){
      document.querySelectorAll('[data-motion="tilt"]').forEach(function(host){
        var card = host.querySelector('[data-tilt-target]');
        var glow = host.querySelector('.spread-glow');
        if (!card) return;
        var rx = 0, ry = 0, tx = 0, ty = 0, raf = null;

        function loop(){
          rx += (tx - rx) * 0.15;
          ry += (ty - ry) * 0.15;
          card.style.transform = 'rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg)';
          if (Math.abs(tx - rx) > 0.01 || Math.abs(ty - ry) > 0.01){
            raf = requestAnimationFrame(loop);
          } else {
            raf = null;
          }
        }

        host.addEventListener('mousemove', function(e){
          var rect = host.getBoundingClientRect();
          var px = (e.clientX - rect.left) / rect.width;
          var py = (e.clientY - rect.top) / rect.height;
          ty = (px - 0.5) * 14;
          tx = (0.5 - py) * 10;
          if (glow) glow.style.background = 'radial-gradient(220px circle at ' + (px * 100) + '% ' + (py * 100) + '%, rgba(200,149,74,.28), transparent 70%)';
          if (!raf) raf = requestAnimationFrame(loop);
        });
        host.addEventListener('mouseleave', function(){
          tx = 0; ty = 0;
          if (glow) glow.style.background = 'none';
          if (!raf) raf = requestAnimationFrame(loop);
        });
      });
    }

    /* ---- pointer-tracked glow spotlight (data-motion="glow") ----
       Sets --mx/--my (percent) on the card so its CSS ::before radial-
       gradient (see .howit-card in spiritpath.css) follows the cursor.
       Desktop pointer only, same guard as the tilt effect above. */
    if (hasHover && !reduceMotion){
      document.querySelectorAll('[data-motion="glow"]').forEach(function(card){
        card.addEventListener('mousemove', function(e){
          var rect = card.getBoundingClientRect();
          card.style.setProperty('--mx', ((e.clientX - rect.left) / rect.width * 100).toFixed(1) + '%');
          card.style.setProperty('--my', ((e.clientY - rect.top) / rect.height * 100).toFixed(1) + '%');
        });
      });
    }

  }
})();
